import * as React from 'react';
import { UIText1, UIText3 } from '@cian/ui-kit';

import * as styles from './PhoneConfirmation.css';

interface IPhoneConfirmationProps {
  phone: string;
  changeNumber: React.ReactNode;
  confirmationInput: React.ReactNode;
  resend: React.ReactNode;
  countdown: React.ReactNode;
  error?: string;
}

export const PhoneConfirmation = ({
  phone,
  changeNumber,
  confirmationInput,
  resend,
  countdown,
  error,
}: IPhoneConfirmationProps): React.JSX.Element => {
  return (
    <div data-testid="PhoneConfirmationModalWindowContent" className={styles['content']}>
      <div>
        <UIText1 display="inline">Отправили его на </UIText1>
        <UIText1 display="inline" fontWeight="bold">
          {phone}
        </UIText1>
      </div>
      {changeNumber}
      <div className={styles['confirmation']}>
        {confirmationInput}
        <div className={styles['error']}>{error && <UIText3 color="text-negative-default">{error}</UIText3>}</div>
      </div>
      <div className={styles['resend']}>{countdown ? countdown : resend}</div>
    </div>
  );
};
